import React from 'react';

const BannerBrand = (props) => {
  return (
    <div
      className={`flex w-full min-width-200 justify-center rounded p-2 ${props.iconContainerClassName}`}
    >
      <div className="flex flex-col justify-center">
        <div className="ml-2">
          <i className={`fa fa-${props.icon} text-lg ${props.iconClassName}`} />
        </div>
      </div>
    </div>
  );
};

export default BannerBrand;
